import './ClickableCode.scss';
import { useState } from 'react';
import Fade from 'react-bootstrap/Fade';

export interface ClickableCodeProps {
  children: string
}

export default function ClickableCode({ children }: ClickableCodeProps) {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);
  const onClick = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    return navigator.clipboard.writeText(children);
  };

  // noinspection RequiredAttributes
  return <>
    <span>
      <code
        onClick={onClick}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >"{children}"</code>
    </span>
    <Fade in={copied || show}>
      <i className="text-muted px-2">
        {copied ? 'Copied to clipboard!' : 'Click to copy to clipboard.'}
      </i>
    </Fade>
  </>;
}
